<template>
  <div id="page-product-form">
    <vs-row>
      <vs-col>
        <card-page card-title="Risk Codes">
          <vue-element-loading :active="busy"></vue-element-loading>
          <div :class="[
                'form-wrapper',
                showForm ? '' : 'empty-wrapper'
              ]"
          >
            <div class="flex justify-center m-4" v-if="!showForm">
              <p>No Risk Codes have been added</p>
            </div>
            <vue-form-generator
                v-else
                class="mt-4 readonly-form facilities crud-additive-form bordered-buttons"
                ref="additiveForm"
                :model="value"
                :options="formOptions"
                :schema="schema"
            />
            <div :class="[
                'flex add-button-wrapper',
                showForm ? 'justify-end' : 'justify-center'
              ]"
            >
              <vs-button
                  class="mx-4 mb-4"
                  v-if="true || componentAccess.canCreate.access"
                  @click="goToCreate"
              >
                Add
              </vs-button>
            </div>
          </div>
        </card-page>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>

import FormModelMixin from '@/components/mixins/FormModelMixin';
import { selectOptions, arrayOptions } from '@/components/form/FormElementOption';
import AdditiveWidget from '@/components/form/fields/AdditiveWidget';
import CardPage from '../../../../components/Views/CardPage';
import CanAccessMixin from '@/components/mixins/CanAccessMixin';

export default {
  name: 'SectionRiskCodesAdditiveForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  components: {
    AdditiveWidget,
    CardPage,
  },
  mixins: [FormModelMixin, CanAccessMixin],
  data() {
    return {
      componentAccess: {
        canDelete: {
          route: 'facilities.sections.riskCodes.delete',
          access: false,
        },
        canCreate: {
          route: 'facilities.sections.riskCodes.create',
          access: false,
        },
      },
      additiveForms: [
        'formRiskCode',
      ],
      model: {
        risk_codes: [],
      },
      schema: {
        groups: [
          {
            styleClasses: 'text-black w-full',
            fields: [
              {
                model: 'risk_codes',
                ...arrayOptions,
                hideAddButton: true,
                showRemoveButton: false,
                items: {
                  type: 'object',
                  schema: {
                    groups: [
                      {
                        styleClasses: 'w-11/12 content',
                        fields: [
                          {
                            disabled: true,
                            type: 'vueMultiSelect',
                            inputType: 'text',
                            styleClasses: 'w-1/3',
                            label: 'Risk Code',
                            model: 'LloydsRiskCode_FK',
                            values: () => this.riskCodes,
                            selectOptions,
                          },
                          {
                            disabled: true,
                            type: 'input',
                            inputType: 'text',
                            styleClasses: 'w-1/3',
                            label: 'OSND',
                            model: 'OriginalSigningNumberDate',
                          },
                          {
                            disabled: true,
                            type: 'input',
                            inputType: 'text',
                            styleClasses: 'w-1/3',
                            label: 'UCR',
                            model: 'UCR',
                          },
                        ],
                      },
                      {
                        styleClasses:
                            'w-1/12 crud-buttons',
                        fields: [
                          {
                            type: 'awesomeButton',
                            styleClasses: 'awesome-form-button edit',
                            buttonOptions: {
                              route: {
                                name: 'facilities.sections.riskCodes.edit',
                                routeParam: 'riskCodeId',
                              },
                              icon: {
                                prefix: 'fal',
                                iconName: 'pencil'
                              },
                            },
                          },
                          {
                            type: 'awesomeButton',
                            styleClasses: 'awesome-form-button delete',
                            buttonOptions: {
                              icon: {
                                prefix: 'fal',
                                iconName: 'times'
                              },
                            },
                            onClick: async (model) => {
                              this.$emit(
                                  'deleteRiskCode',
                                  model.id
                              )
                            }
                          }
                        ]
                      }
                    ]
                  }
                }
              },
            ]
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      riskCodes: [],
      options: [
        {
          endpoint: () => this.$api.productLloydsRiskCode.list(),
          optionsFieldName: 'riskCodes',
          nameFieldName: 'LloydsRiskCode',
          idFieldName: 'LloydsRiskCode_FK',
          modelArrayName: 'risk_codes',
        },
      ],
    };
  },
  computed: {
    showForm() {
      return this.value.risk_codes
          ? this.value.risk_codes.length
          : false;
    },
    showRemoveButton() {
      return true; // FOR TESTING

      return this.componentAccess.canDelete.access;
    }
  },
  methods: {
    goToCreate() {
      this.$router.push({ name: 'facilities.sections.riskCodes.create' })
    },
  },
};
</script>
